import http from '@/utils/http/index';

// 获取角色列表
export function getRoleList(params) {
  return http.get('/role/list', { params });
}

// 删除角色
export function deleteRole(roleId) {
  return http.post('/role/delete', {
    id: roleId,
  });
}

// 获取权限资源列表
export function getResourceList() {
  return http.get('/resource/list?userType=MERC');
}

// 获取角色列表,用于下拉选择框
export function getRoleNames() {
  return http.get('/role/getRoleName');
}

// 检查角色是否正在被使用
export function getRoleIsUsed(roleId) {
  return http.get(`/role/isUseByRoleId?id=${roleId}`);
}

// 新增角色权限
export function saveRole(data) {
  return http.post('/role/add', data);
}

// 更新角色权限
export function updateRole(data) {
  return http.post('/role/edit', data);
}

// 获取角色权限 用户编辑
export function getRolePermission(roleId) {
  return http.get(`/roleResource/getUserMenuByRoleId?roleId=${roleId}`);
}

// 角色权限详情
export function getRoleDetail(roleId) {
  return http.get(`/roleResource/getInfoByRoleId?id=${roleId}`);
}
